import { render, staticRenderFns } from "./StatisticsTradeTurnover.vue?vue&type=template&id=b30519f0&"
import script from "./StatisticsTradeTurnover.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTurnover.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTurnover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports